export default "__VITE_ASSET__C9otnfky__"